module.exports = __webpack_public_path__ + "img/sclose.9a85fd44.png";